import { defineMessages } from 'react-intl'

export default defineMessages({
  searchPlaceholder: {
    id: 'search-inputs.search-placeholder',
    defaultMessage: 'Search events...',
  },
})
